import Typography from "Components/CommonComponents/Typography";
import MyScheduleDateView from "Pages/MySchedule/MyScheduleDateView";
import React, { useEffect, useRef } from "react";
import { Card } from "reactstrap";
import { format } from "date-fns";

interface IMyScheduleDatelist {
  scheduleData?: any;
  screen?: any;
  rangeStartDate?: any;
  rangeEndDate?: any;
  todayDate?: any;
  handleDateSelection?: any;
  statusResponseMap?: any;
  todaySchedules?: any;
  isNotmarkedVisible?: any;
  totalUnmarkedLecture?: any;
  filterState?: any;
  dateRanges?: any;
}
function MyScheduleDateList({
  scheduleData,
  todayDate,
  handleDateSelection,
  statusResponseMap,
  todaySchedules,
  isNotmarkedVisible,
  totalUnmarkedLecture,
  dateRanges,
  screen,
}: IMyScheduleDatelist) {
  const scrollRef = useRef(null);
  const dateViewData = scheduleData ? scheduleData : [];
  const unmarkedLecture =
    todaySchedules && Array.isArray(todaySchedules)
      ? todaySchedules.filter((item: any) => item.syllabusStatus == "Unmarked")
      : [];
  const unmarkedLength =
    unmarkedLecture && Array.isArray(unmarkedLecture)
      ? unmarkedLecture.length
      : 0;
  const totalLength = todaySchedules && todaySchedules.length;

  useEffect(() => {
    const selectedItem = document.querySelector(".selecteddateItemStyle");
    if (selectedItem) {
      selectedItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [todayDate]);
  return (
    <Card className="dateListContainer">
      <div className="dateItemStyleMain">
        {isNotmarkedVisible ? (
          <Typography variant="semiboldheading" color="black">
            Unmarked : {totalUnmarkedLecture ? totalUnmarkedLecture || 0 : 0}
          </Typography>
        ) : (
          <Typography variant="semiboldheading" color="black">
            {dateRanges?.[0].startDate &&
              format(new Date(dateRanges?.[0].startDate), "dd MMM")}
            -
            {dateRanges?.[0].endDate &&
              format(new Date(dateRanges?.[0].endDate), "dd MMM")}
          </Typography>
        )}
      </div>
      <div className="dateItemStyleList">
        {dateViewData.map((item: any, index: any) => {
          return (
            <div
              key={index}
              className={
                todayDate == item ? "selecteddateItemStyle" : "dateItemStyle"
              }
              onClick={() => handleDateSelection(item)}
              ref={todayDate == item ? scrollRef : null}
            >
              <MyScheduleDateView
                dateItem={item}
                scheduleData={scheduleData}
                active={todayDate == item}
                statusResponseMap={statusResponseMap}
                unmarkedLecture={unmarkedLength}
                totalLength={totalLength}
                isNotmarkedVisible={isNotmarkedVisible}
                screen={screen}
              />
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export default MyScheduleDateList;
